import { getCartId } from "./cartId";
import { getEzioId } from "./id";

type Fetch = typeof fetch;
type FetchParameters = Parameters<Fetch>;
type FetchReturn = ReturnType<Fetch>;

export const httpClient = (...params: FetchParameters): FetchReturn => {
    const [req, info] = params;

    const url =
        typeof req === "string" ? import.meta.env.VITE_RETO_URL + req : req;

    const ezioId = getEzioId();
    const cartId = getCartId();

    const headers = {
        ...info?.headers,
        ...(ezioId ? { "self-checkout-terminal-id": ezioId } : undefined),
        ...(cartId ? { "cart-id": cartId } : undefined)
    };

    return fetch(url, { ...info, headers });
};

export const throwOnFailure = (response: Response): Response => {
    if (!response.ok)
        throw new Error(
            `Request to ${response.url} failed with status ${response.status}`
        );

    return response;
};
